/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Reject_WhyInputs */

const en_pol_reject_why = /** @type {(inputs: Pol_Reject_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why was it refused? See the AI provider policy.`)
};

const id_pol_reject_why = /** @type {(inputs: Pol_Reject_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenapa ditolak? Lihat kebijakan penyedia AI.`)
};

/**
* | output |
* | --- |
* | "Why was it refused? See the AI provider policy." |
*
* @param {Pol_Reject_WhyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_reject_why = /** @type {((inputs?: Pol_Reject_WhyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Reject_WhyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_reject_why(inputs)
	return en_pol_reject_why(inputs)
});